export const SESSION_STORAGE_KEY = 'bday-plan-state';
export const FLAT_COORDINATES = [53.909493, 27.575467];
export const RESTAURANT_COORDINATES = [53.908434, 27.575951];
export const CINEMA_COORDINATES = [53.897605, 27.552479];
export const DESTANCE_TO_DESTINATION = 0.15;
export const PUSHOVER_USER_ID = 'ut6wkdrxkrcjpixc578cjbyzdpgmbc';
export const PUSHOVER_API_KEY = 'abny5eor7j8pk73w7ubxd5vtx4cksq';
export const CIPHER_TEXT = 'U2FsdGVkX18tK6Gcviwgt9aJ7HK5ULlFaaaU0fxBLis=';
export const TAXI_LINK = `https://3.redirect.appmetrica.yandex.com/route?start-lat=53.872289&start-lon=27.599192&end-lat=${FLAT_COORDINATES[0]}&end-lon=${FLAT_COORDINATES[1]}&level=70&appmetrica_tracking_id=1178268795219780156`;
